export default __webpack_public_path__ + "static/media/PlanDental.ef097307.svg";